import { useQuery } from "@tanstack/react-query";
import React, { useContext, useState } from "react";
import toast from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { TypeAnimation } from "react-type-animation";
import { AuthContext } from "../../../contexts/AuthProvider";
import ConfirmationModal from "../../Shared/ConfirmationModal/ConfirmationModal";
import Loading from "../../Shared/Loading/Loading";

const MyProducts = () => {
  const { user } = useContext(AuthContext);
  const [deletingProduct, setDeletingProduct] = useState(null);

  const closeModal = () => {
    setDeletingProduct(null);
  };

  const {
    data: products,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      try {
        const res = await fetch(
          "https://recycle-hut-server.vercel.app/products",
          {}
        );
        const data = await res.json();
        return data;
      } catch (error) { }
    },
  });

  const handleSalesStatus = (myProduct) => {
    fetch(`https://recycle-hut-server.vercel.app/products/${myProduct._id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success(
            `This "${myProduct.productName}" is sold successfully..`
          );
          refetch();
        } else {
          toast.error("An error occoured! Please try again!");
        }
      });
  };

  const handleDeleteProduct = (product) => {
    fetch(`https://recycle-hut-server.vercel.app/products/${product._id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.deletedCount > 0) {
          refetch();
          toast.success(`"${product.productName}" deleted successfully`);
        }
      });
  };

  if (isLoading) {
    return <Loading></Loading>;
  }

  const myProducts = products.filter(
    (product) => product.sellerEmail === user?.email
  );

  return (
    <div className="p-5 md:p-8" data-aos="fade-left" data-aos-duration="1500">
      {myProducts?.length === 0 ? (
        <h3 className="text-red-500 font-bold text-[20px] mt-10 flex justify-center items-center w-[90%] mx-auto h-[60vh] md:h-[75vh]">
          <TypeAnimation
            sequence={["You have no added Phones! Please add a Phone", 3000]}
            speed={50}
            cursor={false}
            repeat={Infinity}
          />
        </h3>
      ) : (
        <>
          <div className="flex items-center gap-x-[6px]">
            <span className="text-[22px] md:text-[26px] mb-4 lg:mb-5 text-blue-700 font-bold mt-[-20px] md:mt-[-25px] lg:mt-[-11px] opacity-80 my-transition-4">
              <TypeAnimation
                sequence={[`My Phones`, 3000]}
                speed={50}
                cursor={false}
                repeat={Infinity}
              />
            </span>
            <span className="text-[22px] md:text-[26px] mb-4 lg:mb-5 text-blue-700 font-bold mt-[-20px] md:mt-[-25px] lg:mt-[-11px] opacity-90">
              ({myProducts.length})
            </span>
          </div>

          <div className="xl:hidden mb-[15px] mt-[-11px] text-green-600 font-semibold">
            <small>
              <TypeAnimation
                sequence={[
                  `Please! Scroll  Right side to see more Table Columns..`,
                  3000,
                ]}
                speed={70}
                cursor={true}
                repeat={Infinity}
              />
            </small>
          </div>

          <div className="overflow-x-auto shadow-xl rounded-lg uncommon">
            <table className="table w-full">
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Added Phone Name</th>
                  <th>Image</th>
                  <th>Phone Category</th>
                  <th>Posted Date</th>
                  <th>Phone Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {myProducts.map((myProduct, i) => (
                  <tr key={myProduct._id} className="hover">
                    <th>{i + 1}</th>
                    <td>{myProduct.productName}</td>
                    <td>
                      <PhotoProvider
                        speed={() => 800}
                        easing={(type) =>
                          type === 2
                            ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                            : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                        }
                      >
                        <PhotoView src={myProduct.productImg}>
                          <figure>
                            <LazyLoadImage
                              src={myProduct.productImg}
                              alt={myProduct.productName}
                              width="50px"
                              placeholderSrc={myProduct.productImg}
                              effect="blur"
                              title={myProduct.productName}
                              style={{ objectFit: "cover", cursor: "pointer" }}
                            />
                          </figure>
                        </PhotoView>
                      </PhotoProvider>
                    </td>
                    <td>{myProduct.category}</td>
                    <td>{myProduct.postedDate}</td>

                    <td>
                      {myProduct?.salesStatus !== "sold" ? (
                        <button
                          onClick={() => handleSalesStatus(myProduct)}
                          className="btn btn-xs btn-accent bg-cyan-500 text-white"
                        >
                          Available
                        </button>
                      ) : (
                        <>
                          <span className="mr-2 text-red-500 font-bold">
                            Sold Out
                          </span>
                        </>
                      )}
                    </td>

                    <td>
                      <label
                        onClick={() => setDeletingProduct(myProduct)}
                        htmlFor="confirmation-modal"
                        className="btn btn-xs btn-error bg-red-500 hover:bg-red-600 text-white"
                      >
                        Delete
                      </label>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {deletingProduct && (
            <ConfirmationModal
              title={`Are you sure to delete this phone?`}
              message={`Deleting of "${deletingProduct.productName}" can't be undone!`}
              successAction={handleDeleteProduct}
              successButtonName="Delete"
              modalData={deletingProduct}
              closeModal={closeModal}
            ></ConfirmationModal>
          )}
        </>
      )}
    </div>
  );
};

export default MyProducts;
